module.exports = __webpack_public_path__ + "static/media/phone.d6b920b0.svg";